/* PKCE (RFC 7636, метод S256) — ПРИВЯЗКА КОДА К ВКЛАДКЕ, КОТОРАЯ НАЧАЛА ВХОД.

   Перед уходом на Keycloak придумывается случайный `verifier`. В ссылку входа
   (через гейтвей) уезжает только его хэш — `challenge`; сам verifier остаётся
   здесь и уходит вторым шагом, в обмен кода. Keycloak сверяет хэш, поэтому код,
   перехваченный по дороге назад (утёкший адрес возврата, чужая подсунутая
   ссылка `/login?code=…`), без verifier обменять нельзя.

   `sessionStorage`, а не `localStorage`: verifier нужен ОДНОЙ попытке входа в
   ЭТОЙ вкладке, и переживать её незачем. Одноразовый: забирается с удалением. */

const PKCE_KEY = 'aventrae.login.pkce';

function base64url(bytes: Uint8Array): string {
    return btoa(String.fromCharCode(...bytes))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
}

/** Начать попытку входа: запомнить новый verifier и вернуть его challenge.
    Бросает, если хранилище закрыто или `crypto.subtle` нет (не HTTPS). */
export async function newChallenge(): Promise<string> {
    const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)));
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    window.sessionStorage.setItem(PKCE_KEY, verifier);
    return base64url(new Uint8Array(digest));
}

/** Verifier начатого входа — один раз. null: вход начинали не в этой вкладке. */
export function takeVerifier(): string | null {
    try {
        const verifier = window.sessionStorage.getItem(PKCE_KEY);
        window.sessionStorage.removeItem(PKCE_KEY);
        return verifier;
    } catch {
        return null;
    }
}
